<template>
    <div class="emission-lines-table section-block">
        <div class="table-container-compact emission-lines-table-scroll">
            <table class="table-compact">
                <thead>
                    <tr>
                        <th class="text-center" rowspan="2">기간</th>
                        <th class="text-center col-sep" rowspan="2">시설</th>
                        <th class="text-center col-sep" rowspan="2">카테고리</th>
                        <th class="text-center col-sep" rowspan="2">Scope</th>
                        <th class="text-center gas-group-head col-sep" colspan="6">온실가스 배출량 (kgGHG)</th>
                        <th class="text-center gas-group-head col-sep" colspan="6">CO2 환산량 (kgCO2eq)</th>
                        <th class="text-center col-sep" rowspan="2">배출량<br />(kgCO2eq)</th>
                    </tr>
                    <tr>
                        <th class="text-center num-th col-sep">CO2</th>
                        <th class="text-center num-th">CH4</th>
                        <th class="text-center num-th">N2O</th>
                        <th class="text-center num-th">HFCs</th>
                        <th class="text-center num-th">PFCs</th>
                        <th class="text-center num-th">SF6</th>
                        <th class="text-center num-th col-sep">CO2</th>
                        <th class="text-center num-th">CH4</th>
                        <th class="text-center num-th">N2O</th>
                        <th class="text-center num-th">HFCs</th>
                        <th class="text-center num-th">PFCs</th>
                        <th class="text-center num-th">SF6</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-if="loading">
                        <td :colspan="tableColspan" class="text-center">
                            <i class="fas fa-spinner fa-spin"></i> 로딩 중...
                        </td>
                    </tr>
                    <tr v-else-if="items.length === 0">
                        <td :colspan="tableColspan" class="text-center empty">조회된 데이터가 없습니다</td>
                    </tr>
                    <tr v-else v-for="row in items" :key="rowKey(row)">
                        <td class="text-center">{{ formatTimeKey(row) }}</td>
                        <td class="text-center col-sep">{{ formatFacility(row.facilityCode) }}</td>
                        <td class="text-center col-sep">{{ formatCategory(row.categoryCode) }}</td>
                        <td class="text-center col-sep">{{ formatScope(row.scope) }}</td>
                        <td class="text-right num-cell col-sep">{{ row.CO2 }}</td>
                        <td class="text-right num-cell">{{ row.CH4 }}</td>
                        <td class="text-right num-cell">{{ row.N2O }}</td>
                        <td class="text-right num-cell">{{ row.HFCs }}</td>
                        <td class="text-right num-cell">{{ row.PFCs }}</td>
                        <td class="text-right num-cell">{{ row.SF6 }}</td>
                        <td class="text-right num-cell col-sep">{{ row.CO2eqCO2 }}</td>
                        <td class="text-right num-cell">{{ row.CO2eqCH4 }}</td>
                        <td class="text-right num-cell">{{ row.CO2eqN2O }}</td>
                        <td class="text-right num-cell">{{ row.CO2eqHFCs }}</td>
                        <td class="text-right num-cell">{{ row.CO2eqPFCs }}</td>
                        <td class="text-right num-cell">{{ row.CO2eqSF6 }}</td>
                        <td class="text-right num-cell num-total col-sep">{{ row.co2eqTotal }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import CarbonCodes from "@/submodules/carbon-plugin/codes";

export default {
    name: "EmissionLinesTable",
    props: {
        items: { type: Array, default: () => [] },
        loading: { type: Boolean, default: false },
        facilityNameMap: { type: Object, default: () => ({}) },
        categoryNameMap: { type: Object, default: () => ({}) },
    },
    computed: {
        tableColspan() {
            // 기간 + 시설 + 카테고리 + Scope + 질량6 + CO2eq6 + 합계
            return 17;
        },
    },
    methods: {
        rowKey(row) {
            return `${row.mode}-${row.lineIdx}-${row.inventoryKey ?? "x"}-${row.timeKey ?? "t"}`;
        },
        formatTimeKey(row) {
            const v = row?.timeKey;
            if (!v) return "-";
            const s = String(v);
            if (row?.mode === "annual") return s;
            if (s.length === 6) return `${s.slice(0, 4)}.${s.slice(4, 6)}`;
            return s;
        },
        formatScope(scope) {
            if (scope == null) return "-";
            const n = Number(scope);
            if (Number.isNaN(n) || n < 1 || n > 3) return String(scope);
            const scopeCode = `SCOPE${n}`;
            const label = CarbonCodes.scopeType?.getLabel?.(scopeCode);
            return label && label !== scopeCode ? label : `S${n}`;
        },
        formatCount(v) {
            if (v == null) return "-";
            const n = Number(v);
            if (Number.isNaN(n)) return "-";
            return n.toLocaleString("ko-KR");
        },
        formatNum(v) {
            if (v == null) return "-";
            const n = Number(v);
            if (Number.isNaN(n)) return "-";
            // return n.toLocaleString("ko-KR", { maximumFractionDigits: 2 });
            return n.toLocaleString("ko-KR");
        },
        formatInventoryStat(value) {
            if (!value) return "—";
            return CarbonCodes.inventoryStat.getLabel(value) || String(value);
        },
        formatFacility(code) {
            if (!code) return "—";
            const c = String(code);
            const name = this.facilityNameMap?.[c];
            return name ?? c;
        },
        formatCategory(code) {
            if (!code) return "—";
            const c = String(code);
            const name = this.categoryNameMap?.[c];
            return name ?? c;
        },
    },
};
</script>

<style scoped>
.emission-lines-table {
    width: 100%;
}

.emission-lines-table-scroll {
    overflow-x: auto;
    max-width: 100%;
}

.gas-group-head {
    font-size: 11px;
    font-weight: 600;
    white-space: nowrap;
}

.num-th {
    font-size: 11px;
    white-space: nowrap;
    min-width: 4.5rem;
}

.num-cell {
    font-variant-numeric: tabular-nums;
    font-size: 12px;
    white-space: nowrap;
}

.num-total {
    font-weight: 600;
}

/* 세로 구분선: 기간 | 시설 | 카테고리 | Scope | 온실가스 | CO2환산량 | 배출량 */
.col-sep {
    border-left: 1px solid #cbd5e1;
}
</style>
